import React, { FC, ReactElement } from 'react';
import Link from 'next/link';
import { OtherLocationCountry } from '../types';

type OtherLocations = {
    randomCountries: OtherLocationCountry[];
};

const OtherLocations: FC<OtherLocations> = ({ randomCountries }): ReactElement => {
    const randomCountriesList = randomCountries.map((country: OtherLocationCountry) => {
        return (
            <li className="freight-forwarder-landing__other-locations-list-item" key={country.id}>
                <Link className="new-link arrow" href={`/freight-forwarder/${country.url}`}>
                    {country.name}
                    <svg className="link-arrow directionRight" 
                        viewBox="0 0 10 10" 
                        aria-hidden="true"
                    >
                        <path className="link-arrow__line" d="M1 5h7" />
                        <path className="link-arrow__tip" d="M2 1l4 4-4 4" />
                    </svg>
                </Link>
            </li>  
        );
    });

    return (
        <section className="freight-forwarder-landing__other-locations">
            <div className="container">
                <h2 className="freight-forwarder-landing__other-locations-title">
                    Other Locations
                </h2>
                <ul className="freight-forwarder-landing__other-locations-list">
                    {randomCountriesList}
                </ul>
            </div>
        </section>
    );
};

export default OtherLocations;
